import { Button, Stack, Typography, useTheme } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { UserX } from "lucide-react";
import { useState } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { device } from "web_myplann/Utils/device";

const PageResources = Resources.Profile.MissingAdvisor;

export const MissingAdvisor = () => {
	const theme = useTheme();
	const { t } = useResource();
	const queryClient = useQueryClient();
	const [isLoggingOut, setIsLoggingOut] = useState(false);

	const handleLogOut = async () => {
		if (isLoggingOut) {
			return;
		}
		setIsLoggingOut(true);
		try {
			if (window.ReactNativeWebView) {
				await device.logOut();
			}
			queryClient.clear();
		} finally {
			setIsLoggingOut(false);
		}
	};

	return (
		<Stack
			alignItems="center"
			gap={1.5}
			sx={{
				position: "absolute",
				top: "50%",
				left: "50%",
				transform: "translate(-50%, -50%)",
				width: "80%",
			}}
		>
			<UserX size={48} color={theme.palette.grey[600]} />
			<Typography fontWeight={600} fontSize={16}>
				{t(PageResources.title)}
			</Typography>
			<Typography
				variant="body2"
				color={theme.palette.grey[500]}
				textAlign="center"
				maxWidth={280}
			>
				{t(PageResources.description)}
			</Typography>
			<Button onClick={handleLogOut} disabled={isLoggingOut}>
				{t(PageResources.logOut)}
			</Button>
		</Stack>
	);
};
